import { Box } from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

import config from 'configs/app';
import useIsMobile from 'lib/hooks/useIsMobile';
import * as mixpanel from 'lib/mixpanel/index';
import { Image } from 'toolkit/chakra/image';
import { Link } from 'toolkit/chakra/link';
const getGasFeature = config.features.getGasButton;

const GetGasButton = () => {
  const isMobile = useIsMobile(false);

  const onGetGasClick = React.useCallback(() => {
    mixpanel.logEvent(mixpanel.EventTypes.BUTTON_CLICK, { Content: 'Get gas', Source: 'address' });
  }, []);

  if (getGasFeature.isEnabled && !isMobile && getGasFeature.items && getGasFeature.items.length > 0) {
    return (
      <>
        { getGasFeature.items.map((item, index) => {
          try {
            const dappId = item.dappId;
            const urlObj = new URL(item.url);

            urlObj.searchParams.append('utm_source', 'tjrscan');
            urlObj.searchParams.append('utm_medium', 'address');

            const url = urlObj.toString();
            const isInternal = typeof dappId === 'string';

            return (
              <React.Fragment key={ index }>
                <Box h="1px" w="8px" bg="border.divider" mx={ 1 }/>
                <Link
                  href={ isInternal ? route({ pathname: '/apps/[id]', query: { id: dappId, url } }) : url }
                  external={ !isInternal }
                  display="flex"
                  alignItems="center"
                  textStyle="xs"
                  onClick={ onGetGasClick }
                >
                  { item.logoUrl && (
                    <Image
                      src={ item.logoUrl }
                      alt={ item.name }
                      boxSize="14px"
                      mr={ 1 }
                    />
                  ) }
                  { item.name }
                </Link>
              </React.Fragment>
            );
          } catch (error) {
            return null;
          }
        }) }
      </>
    );
  }

  return null;
};

export default GetGasButton;
